import cleanPath from './cleanPath';
import encodePathForUri from './encodePathForUri';
import encodePathForUriComponent from './encodePathForUriComponent';
import getFileExtension from './getFileExtension';
import getFileName from './getFileName';
import getFileCaption from './getFileCaption';
import getFileMimeType from './getFileMimeType';
import getRepositoryItemName from './getRepositoryItemName';
import splitPath from './splitPath';
import getFileThumbnailPath from './getFileThumbnailPath';
import getFilePreviewPath from './getFilePreviewPath';
import addDesignTrunk from './addDesignTrunk';
import stripDesignTrunkFromPath from './stripDesignTrunkFromPath';
import isFile from './isFile';
import isFolder from './isFolder';
import getParentFolderPath from './getParentFolderPath';
import getFolderPath from './getFolderPath';
import isRelative from './isRelative';
import relative from './relative';
import absolute from './absolute';
export default {
  cleanPath: cleanPath,
  encodePathForUri: encodePathForUri,
  encodePathForUriComponent: encodePathForUriComponent,
  getFileExtension: getFileExtension,
  getFileName: getFileName,
  getFileCaption: getFileCaption,
  getFileMimeType: getFileMimeType,
  getRepositoryItemName: getRepositoryItemName,
  splitPath: splitPath,
  getFileThumbnailPath: getFileThumbnailPath,
  getFilePreviewPath: getFilePreviewPath,
  addDesignTrunk: addDesignTrunk,
  stripDesignTrunkFromPath: stripDesignTrunkFromPath,
  isFile: isFile,
  isFolder: isFolder,
  getParentFolderPath: getParentFolderPath,
  getFolderPath: getFolderPath,
  isRelative: isRelative,
  relative: relative,
  absolute: absolute
};